import {
  YEAR2_ASSESSMENT_CRITERIA_VERSION,
  YEAR2_CHAIR_CRITERIA,
  YEAR2_RATING_SCALE,
} from '../data/year2ChairCriteria';
import { YEAR2_SQUAD_CRITERIA_BY_COUNCIL } from '../data/year2SquadCriteriaByCouncil';

function clampCouncilNumber(value) {
  const num = Number(value);
  if (num >= 1 && num <= 5) return num;
  return 1;
}

function asStringArray(value) {
  if (!Array.isArray(value)) return [];
  return value.map((item) => String(item)).filter(Boolean);
}

function localCriteriaForCouncil(councilNumber) {
  const council = YEAR2_SQUAD_CRITERIA_BY_COUNCIL[councilNumber] || YEAR2_SQUAD_CRITERIA_BY_COUNCIL[1];

  return {
    version: YEAR2_ASSESSMENT_CRITERIA_VERSION,
    council_number: councilNumber,
    rating_scale: YEAR2_RATING_SCALE,
    chair: {
      strengths: [...YEAR2_CHAIR_CRITERIA.strengths],
      coaching: [...YEAR2_CHAIR_CRITERIA.coaching],
    },
    squad: {
      council_number: council.council_number,
      title: council.title,
      tagline: council.tagline,
      strengths: [...council.strengths],
      coaching: [...council.coaching],
    },
  };
}

function hasCompleteCriteriaPayload(apiCriteria) {
  return Boolean(
    apiCriteria?.chair?.strengths?.length
    && apiCriteria?.chair?.coaching?.length
    && apiCriteria?.squad?.strengths?.length
    && apiCriteria?.squad?.coaching?.length
    && apiCriteria?.rating_scale?.length
  );
}

/** Prefer workspace `criteria` from API; fall back to local mirror files. */
export function resolveYear2Criteria(workspace, councilNumber) {
  const council = clampCouncilNumber(councilNumber);
  const apiCriteria = workspace?.criteria;

  if (hasCompleteCriteriaPayload(apiCriteria)) {
    return {
      version: apiCriteria.version || YEAR2_ASSESSMENT_CRITERIA_VERSION,
      council_number: apiCriteria.council_number ?? council,
      rating_scale: apiCriteria.rating_scale,
      chair: {
        strengths: asStringArray(apiCriteria.chair.strengths),
        coaching: asStringArray(apiCriteria.chair.coaching),
      },
      squad: {
        council_number: apiCriteria.squad.council_number ?? council,
        title: apiCriteria.squad.title || '',
        tagline: apiCriteria.squad.tagline || '',
        strengths: asStringArray(apiCriteria.squad.strengths),
        coaching: asStringArray(apiCriteria.squad.coaching),
      },
    };
  }

  return localCriteriaForCouncil(council);
}

export function getRatingBandLabel(rating, ratingScale = YEAR2_RATING_SCALE) {
  const num = Number(rating);
  if (!Number.isFinite(num) || num < 1 || num > 10) return '';

  const band = (ratingScale || []).find((entry) => num >= entry.min && num <= entry.max);
  return band?.label || '';
}

export function keywordSetsForRole(criteria, role) {
  if (role === 'squad') {
    return {
      strengths: criteria.squad.strengths,
      coaching: criteria.squad.coaching,
    };
  }

  return {
    strengths: criteria.chair.strengths,
    coaching: criteria.chair.coaching,
  };
}

export function isRatingPresent(rating) {
  if (rating === '' || rating == null) return false;
  const num = Number(rating);
  return Number.isFinite(num) && num >= 1 && num <= 10;
}